<template>
  <router-view/>
</template>

<script>
export default {
  name: 'RouterWrapper',

};
</script>
